import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';

@Injectable()
export class SubscribableTitleService {
title: BehaviorSubject<string>;
constructor(
    private titleService: Title,
    private meta: Meta
    ) {
    this.title = new BehaviorSubject<string>(this.titleService.getTitle());
}
setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
    this.title.next(newTitle);
}
setMetaThemeColor(color: string) {
    this.meta.addTag({name: 'theme-color', content: color});
}
}



// WEBPACK FOOTER //
// ./src/app/services/subscribable-title.service.ts